<script setup lang="ts">
import TripCard from '@components/ui/hotelPage&view/cards/trip/TripCard.vue';
import type TripPackage from '@itinerary/trip/TripPackage';

const currentModule = useCurrentItineraryModule();
const { autoReservePriceOnly } = moduleToRefs(currentModule.value);

const autoReserveStore = useAutoReserveStore();
const { openAutoReserveModal } = useAutoReserveModal();
const itineraryModule = useCurrentItineraryModule();
const posthog = usePosthog();

const showDetails = ref(false);

const openModal = (pkg?: TripPackage) => {
    if (pkg) {
        autoReserveStore.preSelectPackage = pkg;
        autoReserveStore.selectedPackages = [pkg];
    }
    if (autoReservePriceOnly.value) {
        autoReserveStore.showAll = true;
    }
    openAutoReserveModal('auto-reserve-card-click');
};

const extraAutoReserveItemEnabled = computed(() =>
    posthog.value?.isFeatureEnabled('show-auto-reserve-card-in-available-list')
);
</script>
<template>
    <TripCard
        v-if="
            itineraryModule.extraAutoReserveItem && extraAutoReserveItemEnabled
        "
        class="auto-reserve-extra"
        :is-open-details="showDetails"
        :trip-package="itineraryModule.extraAutoReserveItem as TripPackage"
        :style="{ order: 1 }"
        @show-details="() => (showDetails = true)"
        @hide-details="() => (showDetails = false)"
        @button-clicked="openModal"
    />
</template>
<style scoped lang="scss">
.auto-reserve-extra {
    border: 1px solid usePalette($p-yellow, $p-400) !important;
}
</style>
